import client from './main-client';

export const addOwnerContactApi = (data) => client().post('/borrower-contacts', data);
export const getOwnerContactApi = ({ id, ...params }) => client().get(`/borrower-contacts/${id}`, { params });
export const getAllContactsApi = (params) => client().get('/borrower-contacts', { params });
export const updateOwnerContactApi = (params) => client().patch(`/borrower-contacts/${params.id}`, params);
export const deleteOwnerContactApi = (data) => client().delete(`/borrower-contacts/${data.id}`);
